// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {ImageRecognizedText} from '../search-index/image-recognized-text.js'

export class ImageSearchIndex {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ImageSearchIndex {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsImageSearchIndex(bb: flatbuffers.ByteBuffer, obj?: ImageSearchIndex): ImageSearchIndex {
    return (obj || new ImageSearchIndex()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsImageSearchIndex(bb: flatbuffers.ByteBuffer, obj?: ImageSearchIndex): ImageSearchIndex {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ImageSearchIndex()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  imageBlocks(index: number, obj?: ImageRecognizedText): ImageRecognizedText | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset
      ? (obj || new ImageRecognizedText()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!
        )
      : null
  }

  imageBlocksLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  version(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0
  }

  static startImageSearchIndex(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addImageBlocks(builder: flatbuffers.Builder, imageBlocksOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, imageBlocksOffset, 0)
  }

  static createImageBlocksVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startImageBlocksVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static addVersion(builder: flatbuffers.Builder, version: number) {
    builder.addFieldInt32(1, version, 0)
  }

  static endImageSearchIndex(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // image_blocks
    return offset
  }

  static createImageSearchIndex(
    builder: flatbuffers.Builder,
    imageBlocksOffset: flatbuffers.Offset,
    version: number
  ): flatbuffers.Offset {
    ImageSearchIndex.startImageSearchIndex(builder)
    ImageSearchIndex.addImageBlocks(builder, imageBlocksOffset)
    ImageSearchIndex.addVersion(builder, version)
    return ImageSearchIndex.endImageSearchIndex(builder)
  }
}
